import { useQuery } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';

import { useChapterAddNewAlias } from '@/module/Author/Chapter/model/ChapterQuery';
import { PublicationNewAliasRequest } from '@/module/Author/Publication/model/PublicationTypes';
import { chapterMembershipOptions } from '@/module/Nomen/ChapterMembership/model/ChapterMembershipModel';

import { Id, useAppNotification } from '@feature/utils';

import { PublicationSearchClaimable } from '../Publication/PublicationSearchClaimable';

export function ChapterSearchClaimable() {
  const notification = useAppNotification();
  const navigate = useNavigate();

  const { data: memberships, isLoading, isError } = useQuery(chapterMembershipOptions.getAll());

  const mutation = useChapterAddNewAlias();
  const onAddNewAlias = (publicationId: Id, request: PublicationNewAliasRequest) =>
    mutation.mutate(
      { chapterId: publicationId, request: request },
      {
        onSuccess: chapter => {
          notification.success();
          navigate({ to: '/author/chapter/$chapterId', params: { chapterId: String(chapter.id) } });
        },
        onError: notification.error,
      },
    );

  return (
    <PublicationSearchClaimable
      memberships={memberships}
      membershipsLoading={isLoading}
      membershipsError={isError}
      onAddNewAlias={onAddNewAlias}
    />
  );
}
